export const ErrorBox = (props: React.PropsWithChildren) => {
  return (
    <div className='border border-gray-200 bg-error-25 shadows-xs h-[52px] flex items-center p-4'>
      {props.children}
    </div>
  );
};
